import { render } from "./PostLikeButton.vue?vue&type=template&id=e149abea&scoped=true"
import script from "./PostLikeButton.vue?vue&type=script&lang=js"
export * from "./PostLikeButton.vue?vue&type=script&lang=js"

import "./post-like-button.scss?vue&type=style&index=0&id=e149abea&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e149abea"]])

export default __exports__